import React from "react";
import { Box, AspectRatio, type AspectRatioProps } from "@chakra-ui/react";
import { AnimationVideo } from "ui/animation-video";
import { ProductShowcase } from "ui/product-showcase";

function CustomerStudioVideo(props: AspectRatioProps) {
  return (
    <AspectRatio
      color="brand.text.light"
      ratio={16 / 9}
      borderRadius="base"
      borderBottomRadius={{ base: "base", sm: "none" }}
      w="100%"
      maxW="840px"
      mx="auto"
      overflow="hidden"
      {...props}
    >
      <AnimationVideo
        mp4="https://cdn.sanity.io/files/pwmfmi47/production/fcffe6d5459959f713e1374524a7c7908c5a53f0.mp4"
        poster="https://cdn.sanity.io/images/pwmfmi47/production/ffa862184a5abe638c3e5c82d74ead49963e6ae6-1348x792.webp"
      />
    </AspectRatio>
  );
}

export function FeatureVideo() {
  return (
    <Box w="100%" mt={{ base: "bigger", sm: "biggest", md: "huge" }}>
      <ProductShowcase
        display={{ base: "none", sm: "block" }}
        variant="coastal"
        productScreen={<CustomerStudioVideo />}
      />

      <CustomerStudioVideo display={{ base: "block", sm: "none" }} />
    </Box>
  );
}
